import {gsap} from "gsap";

const searchModal = {
    tl: null,
    delay: 250,
    progress: 0,

    init: function () {
        let self = this;

        if (!document.querySelector('.c-search-modal')) {
            return;
        } else {

            self._showModal();
            //self._timeline();
        }
    },

    _showModal: function () {
        let self = this;
        //let modalConts = Array.prototype.slice.call(document.querySelectorAll('.c-search-modal'));
        let modalOpenButton = document.querySelectorAll('.js-search-button');
        let modalCloseButtons = document.querySelectorAll('.c-search-modal__close');
        let body = document.querySelector('body');


        modalOpenButton.forEach(function (item) {
            item.addEventListener('click', function () {
                let modalCont = item.parentElement.querySelector('.c-search-modal');
                if (!modalCont.classList.contains('c-search-modal--active')) {
                    modalCont.classList.add('c-search-modal--active');
                    body.classList.add('body-fixed');
                    setTimeout(function() {
                        modalCont.querySelector('.c-search-modal__input').focus()
                    }, 20);

                    self._timeline(modalCont);
                    self.tl.play();
                }
            });
        });

        modalCloseButtons.forEach(function (item) {
            item.addEventListener('click', function () {
                if (item.parentElement.classList.contains('c-search-modal--active')) {
                    self.tl.reverse();
                }
            });
        });
    },

    _timeline: function (modalCont) {

        let reverseComplete = false;
        let self = this;
        let body = document.querySelector('body');


        self.tl = gsap.timeline({paused: true, reversed: true, onReverseComplete: function () {
                reverseComplete = true;
                if(reverseComplete && modalCont.classList.contains('c-search-modal--active')) {
                    modalCont.classList.remove('c-search-modal--active');
                    body.classList.remove('body-fixed');
                    setTimeout(function() {
                        document.querySelector('.c-navbar').focus()
                    }, 20);

                    self.progress = 0;
                    self.tl.kill();
                }
            }});

        self.tl.fromTo(modalCont, 0.4, {top: "-100vw", delay: .2, autoAlpha: 0, ease: 'Power2.inOut'}, {top: 0, autoAlpha: 1})
            .fromTo(modalCont.querySelectorAll('.c-search-modal__content'), .3, {opacity: 0, ease: 'Power2.in'}, {opacity: 1, ease: 'Power2.out'});

        self.tl.progress(self.progress);
    }
};

searchModal.init();

document.addEventListener('LokiRequestEnd', function () {
    searchModal.init();
});